import { getActiveSession } from 'auth/sessionStore';

// The session's user name, cached by AuthGuard from /_auth/me before anything
// mounts — so this is a plain read, not a hook over async state.
export default function useAuthUserFullName(): string | undefined {
  return getActiveSession()?.userName || undefined;
}
